import { useState } from "react";
import { useNavigate } from "react-router";
import { useStateValue } from "../../stateProvider/stateProvider";
import { SET_ROLES,LOGOUT } from "../../constans/reducerActions";
import Toast from "../Toast/Toast";
import Button from "../../components/Button/Button";

import "./Login.css";
import { apiPost } from "../../Functions/utils";
import { LOCAL_STORAGE_ROLES, LOCAL_STORAGE_TOKEN } from "../../constans/roles";
import InputText from "../../components/InputText/InputText";

import { API_URL } from "../../constans/roles";


const Login = () => {
  const [reducer, dispatch] = useStateValue();
  const [login, setLogin] = useState("");
  const [pass, setPass] = useState("");
  const [logging, setLogging] = useState(false);
  const [infoType,setInfoType] = useState("");
  const [info,setInfo] = useState("")

  const nav = useNavigate();

  const handleChange = (type, e) => {
    console.log(e.target)
    if (type === "login") setLogin(e.target.value);
    if (type === "password") setPass(e.target.value);
  };
  

    const handleNoToken = () => {
      setInfo("Błąd logowania, spróbuj ponownie!")
      setInfoType("Fail")
      dispatch({ type: LOGOUT,})
      setLogin("");
      setPass("");
      setLogging(false);
    }

    const handleLoggingError = () => {
      setInfoType("Fail")
      setInfo("Błąd w czasie logowania!")

      console.log('s')
      dispatch({ type: LOGOUT,})
      nav('/login')
    }

    const handleToken = (data) => {

      localStorage.setItem(LOCAL_STORAGE_TOKEN, data.token);
      localStorage.setItem(LOCAL_STORAGE_ROLES, data.roles);
      nav("/")

      dispatch({ type: SET_ROLES, item: { roles: data.roles } });
      setLogging(false);

      window.location.reload(false)
    }

    const clearForm = () => {
      setLogin("");
      setPass("");
    }

  const handleLogin = async () => {
    try {
      setLogging(true);

      console.log('s')

      const json = await apiPost(API_URL+ '/' +"api/user/login",{
        login,
        password: pass,
      })
      
      const data = await json.json();

      if(!data.token)
        return handleNoToken()
      
      handleToken(data)
     
    } catch (err) {
      handleLoggingError()
    }

      clearForm()
  };

  const handleClick = (e) => {
    //e.preventDefault();
    if (!login || !pass) 
        return alert("Nie podano wszystkich danych");

    handleLogin();
  };



  return (
    <div className="register-wrapper">
          {
      infoType &&         
      <Toast  
          infoType={infoType}
          info={info}
          setInfoType={setInfoType}
      />
    }

      
        <form className="register-form">
        {logging && <h3> Logowanie...</h3>}

          <h1 className="register-form__headline_1 uppercase">
            <span style={{fontWeight:'var(--normal-font-weight)', color:'var(--sec-font)'}}>Panel </span>Preview
          </h1>
        
          <h2 className="register-form__headline_2 uppercase">
            Logowanie
          </h2>
          
          <InputText 
            placeholder="Login"
            value={login}
            text="Login: "
            name="login"
            handleChange={(e) => handleChange("login", e)}
          />

        <InputText 
            placeholder="Login"
            isPassword={true}
            value={pass}
            text="Hasło: "
            name="password"
            handleChange={(e) => handleChange("password", e)}
          />

          <Button 
            txt="Zaloguj się"
            click={e => {
              handleClick(e)
            }}
          />

        </form>

      <section className="register-right-section">
        <img
            src="./Images/logo_white.png"
            className="register-right-section__logo"
          />
      </section>

    </div>
  );
};
export default Login;
